import React from 'react'
import { useTranslation } from 'react-i18next'

type Card = {
    id: string;
    imgSrc: string;
    imgAlt: string;
}

const cards: Card[] = [
    {
        id: 'costs',
        imgSrc: '/assets/analytics-down.svg',
        imgAlt: 'analytics-down',
    },
    {
        id: 'admin',
        imgSrc: '/assets/file.svg',
        imgAlt: 'file',
    },
    {
        id: 'calculations',
        imgSrc: '/assets/calculator.svg',
        imgAlt: 'calculator',
    },
]

const WeUnderstandYourPain: React.FC = () => {
    const { t } = useTranslation()

    return (
        <div id="about" className='py-[30px] md:py-20 px-5'>
            <div className='max-w-[1200px] mx-auto w-full'>
                <div className='text-center space-y-4'>
                    <h1 className='text-primary text-[32px] md:text-[48px] leading-10 md:leading-[58px] font-bold'>{t('landing.pain.title')}</h1>
                    <p className='text-darkgray text-[16px] sm:text-[18px] leading-[28px] font-normal tracking-[0.01em]'>{t('landing.pain.subtitle')}</p>
                </div>

                <div className='mt-6 md:mt-10 lg:mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6 xl:gap-8'>
                    {cards.map((card) => (
                        <div key={card.id} className='p-10 bg-white rounded-[20px] border border-[#EEEEEE] shadow-[inset_0px_6px_25px_0px_#ffffff1a]'>
                            <img src={card.imgSrc} alt={card.imgAlt} width={56} height={56} />
                            <h3 className='mt-10 lg:mt-[86px] mb-[23px] text-primary text-[22px] sm:text-[24px] leading-8 font-semibold'>{t(`landing.pain.${card.id}.title`)}</h3>
                            <p className='text-secondary text-[16px] leading-[25px] font-normal font-inter'>{t(`landing.pain.${card.id}.description`)}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default WeUnderstandYourPain